import {
    GET_DEVICES_REQUEST,
    GET_DEVICES_SUCCESS,
    GET_DEVICES_FAILURE,
    ADD_PREVIEW_DEVICES,
    REMOVE_PREVIEW_DEVICES,
    POST_DEVICES_SUCCESS
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: [],
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DEVICES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_DEVICES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.devices,
                isInitialFetch: false,
            };
        case GET_DEVICES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case ADD_PREVIEW_DEVICES: {
            const newDevices = action.payload.devices.map((d) => ({...d, isDisabled: true}));
            return {
                ...state,
                data: [...newDevices, ...state.data],
            };
        }
        case REMOVE_PREVIEW_DEVICES: {
            return {
                ...state,
                data: state.data.filter((f) => !f.isDisabled),
            };
        }
            case POST_DEVICES_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    data: action.payload.devices,
                    isInitialFetch: false,
                };
        default:
            return state;
    }
};